import moment from 'moment';
import { createContext } from 'react';
import { MetricsMap } from './metricsUtils';

export const NO_VALUE = 'N/A';
export const NONE_TAG_VALUE = 'None';
export const DATE_RANGE_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_START_DATE = moment()
    .subtract(6, 'days')
    .format(DATE_RANGE_DATE_FORMAT);
export const DEFAULT_END_DATE = moment().format(DATE_RANGE_DATE_FORMAT);
export const DEFAULT_METRICS = [MetricsMap.CUSTOM_IMPRESSIONS, MetricsMap.CUSTOM_CLICKS, MetricsMap.CUSTOM_INSTALLS];

export const GalleryContext = createContext();

export const TRACK_EVENT_PREFIX = 'Creatives Gallery';
export const CREATIVE_GALLERY_REPORT_TYPE = 'creativeGallery';
export const DEFAULT_AI_FILTERS = ['Keywords'];

export const CardSections = {
    MULTI_VALUED_DIMENSIONS: 'multiValuedDimensions',
    METRICS: 'metrics',
};

export const CREATIVES_TAB = 'CREATIVES';
export const INSIGHTS_TAB = 'INSIGHTS';

export const CreativeTabs = [
    {
        id: CREATIVES_TAB,
        label: 'STATIC.CREATIVE_IQ.CREATIVE_GALLERY.MY_CREATIVES_TAB',
    },
    {
        id: INSIGHTS_TAB,
        label: 'STATIC.CREATIVE_IQ.CREATIVE_GALLERY.INSIGHTS_TAB',
        iconName: 'bulb',
    },
];

export const LayoutConfig = {
    GRID: {
        type: 'grid',
        icon: 'layout-grid',
        tooltip: 'STATIC.TOOLTIPS.GRID_LAYOUT',
    },
    GALLERY: {
        type: 'gallery',
        icon: 'layout-dashboard',
        tooltip: 'STATIC.TOOLTIPS.GALLERY_LAYOUT',
    },
};

export const CreativeFilters = {
    APP: 'App',
    SOURCE: 'Source',
    METRICS: 'Metrics',
    DATE_RANGE: 'Date Range',
    COHORTS: 'Cohorts',
};

export const CREATIVE_TAGS_TAB_ID = 'CREATIVE_TAGS';
export const ANALYSIS_TAB_ID = 'ANALYSIS';
export const CLUSTERED_CREATIVES_TAB_ID = 'SIMILAR_CREATIVES';

export const CreativeCardTabs = [
    {
        id: CREATIVE_TAGS_TAB_ID,
        label: 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.CREATIVE_TAGS_TAB',
        iconName: 'tags',
    },
    {
        id: ANALYSIS_TAB_ID,
        label: 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.ANALYSIS_TAB',
        iconName: 'chart-pie',
    },
    {
        id: CLUSTERED_CREATIVES_TAB_ID,
        label: 'STATIC.PAGES.CREATIVE_GALLERY.CREATIVE_POPUP.SIMILAR_CREATIVES_TAB',
        iconName: 'stack-2',
    }
];

export const Dimensions = {
    APP: 'app',
    SOURCE: 'source',
    HAS_CREATIVE_PREVIEW: 'has_creative_preview',
    CREATIVE_TYPE: 'creative_type',
    CREATIVE_IMAGE_HASH: 'creative_image_hash',
    CREATIVE_EMBEDDING_URL: 'creative_embedding_url',
    CREATIVE_WIDTH: 'creative_width',
    CREATIVE_HEIGHT: 'creative_height',
    CREATIVE_ORIENTATION: 'creative_orientation',
    CREATIVE_ASPECT_RATIO: 'creative_aspect_ratio',
    CREATIVE_VIDEO_DURATION: 'creative_video_duration',
    CREATIVE_VIDEO_DURATION_RANGE: 'creative_video_duration_range',
    CREATIVE_ID: 'creative_id',
    CREATIVE_NAME: 'creative_name',
    ASSET_ID: 'asset_id',
    ASSET_NAME: 'asset_name',
    NORMALIZED_CREATIVE_NAME: 'normalized_creative_name',
    COUNTRY: 'country_field',
    OS: 'os',
    CAMPAIGN_NAME: 'unified_campaign_name',
    CAMPAIGN_ID: 'unified_campaign_id',
    DATE: 'date_field',
};
